"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_jss_1 = __importDefault(require("react-jss"));
const lodash_flowright_1 = __importDefault(require("lodash.flowright"));
const surface_1 = require("../../../../../../surface");
const withInlineValidation_1 = __importDefault(require("../../../../../wrappers/withInlineValidation"));
const links_1 = require("../../../../../utils/links");
const radio_style_1 = __importDefault(require("./radio.style"));
const Radio = props => {
    const { classes, id, options, value = '', disabled, readonly, onChange, formContext } = props;
    const { enumOptions, enumDisabled, inline } = options;
    // check if the widget is locked because of forms links
    const isLocked = links_1.isLockedWidget(id, formContext.links);
    const disabledGroup = disabled || readonly || isLocked;
    const radioBtnWrapperProps = {
        className: classes.radioBtnWrapper,
        'data-is-inline': inline
    };
    return (jsx_runtime_1.jsx("div", Object.assign({}, radioBtnWrapperProps, { children: enumOptions.map(option => {
            const disabledOption = enumDisabled && enumDisabled.indexOf(option.value) !== -1;
            if (enumOptions.length < 2)
                console.error('Minimum 2 options should be added to radio buttons within the JSONSchema');
            return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.radioBtn }, { children: jsx_runtime_1.jsx(surface_1.RadioButton, { showLabel: true, label: option.label, value: option.label, disabled: disabledGroup || disabledOption, handleChange: () => onChange(option.value), checked: option.value === value }, void 0) }), option.label));
        }) }), void 0));
};
exports.Radio = Radio;
exports.default = lodash_flowright_1.default(withInlineValidation_1.default, react_jss_1.default(radio_style_1.default))(exports.Radio);
//# sourceMappingURL=index.js.map